import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import type { ApiStateClient } from './api-state-client.token';

export interface ApiResponse {
  status: string;
  message: string;
  timestamp: string;
}

@Injectable({
  providedIn: 'root'
})
export class ApiStateService implements ApiStateClient {
  private apiUrl = environment.matrixApiUrl;

  constructor(private http: HttpClient) {}

  getStatus(): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(this.apiUrl);
  }
}
